import { convertToRaw, EditorState, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { Entity, formatNumber } from '@debbie/common/dist/index.js';
import { courts, getDirector, getFuldtAnsvaligeDeltagere, getInterestDates, getInterests, getTotalAmount, getCaseInterest, getWarningDate, getCourt, } from '@debbie/common/dist/court/index.js';
import { readyToSubmit } from '@debbie/common/dist/court/auto-submit.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { VoucherTypeIds } from '@debbie/common/dist/economy/vouchers/index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { selectRole } from '@debbie/cortex/dist/me/selectors.js';
import { selectTemplates } from '@debbie/cortex/dist/templates/selectors.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { DateInput, Button, ButtonGroup, Modal, Alert, Checkbox, } from '../../../../index.js';
import { APIBASE } from '../../../../../config.js';
import { encodeText, parseText } from '../../../../../utils/templates.js';
import { Row, Col } from '../../../../Grid/index.js';
import BPDescInput from './BPDescInput.js';
import CourtSelect from './CourtSelect.js';
import Interest from './Interest.js';
import Rubrik6 from './Rubrik6.js';
import Rubrik7 from './Rubrik7.js';
import * as utils from './utils/index.js';
import ObjectComp from '../../../../ObjectComp.js';
import { caseVouchersEntity, useCaseVouchersByCase, } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import q from '@debbie/cortex/dist/query.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { tribunalJobsEntity, tribunalCasesEntity, } from '@debbie/cortex/dist/tribunal/index.js';
import { creditorsEntity, useCreditor, } from '@debbie/cortex/dist/creditors/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { GLTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
const Betalingspaakrav = (props) => {
    const [documentState, setDocumentReactState] = useState({
        ...utils.initialDocumentState,
        ...utils.getDocumentsFromStorage(),
        ...(props.prefill &&
            Object.entries(props.prefill).reduce((acc, [key, value]) => {
                if (typeof value !== 'undefined') {
                    if (['createDate', 'remindingDate'].includes(key)) {
                        acc[key] = moment(value);
                    }
                    else if (key === 'sagsfremstilling') {
                        acc.bpDesc = value;
                    }
                    else if (key === 'courtId' &&
                        courts.find((c) => c.courtId === value)) {
                        acc.court = courts.find((c) => c.courtId === value);
                    }
                    else {
                        acc[key] = value;
                    }
                }
                return acc;
            }, {})),
    });
    const { courtFee, createDate, processInterest, interestFromSubmitOfBPK, remindingDate, preventForkyndt, preventAutDistress, notDirectlyToCivilCourt, sendInfoToEconomyResponsible, addCourtFeeToCase, addCourtDisbursementToClientBilling, addCourtFeeToClientBilling, participatePhoneMeeting, } = documentState;
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, Number(props.caseSeqId)));
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const tenant = useSelector(selectTenant);
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const meRole = useSelector(selectRole);
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const caseInteractionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId);
    const caseInteractions = (h.hasData(caseInteractionsLoadable)
        ? caseInteractionsLoadable.data
        : []) || [];
    const caseUpdates = useSelector((s) => singleCase && selectCaseUpdates(s, singleCase.caseId));
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const templates = useSelector(selectTemplates);
    const contactPerson = customer && getContactPerson(customer);
    const caseVouchers = _caseVouchers ? _caseVouchers : [];
    const [sagsfremstillingEdited, setSagsfremstillingEdited] = useState(false);
    const [editorState, setEditorState] = useState(null);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [economyResponsibleUserId, setEconomyResponsibleUserId] = useState(localStorage.economyResponsibleUserId || null);
    const court = getCourt(contactPerson, documentState.court);
    const totalAmount = getTotalAmount(props.caseSeqId, caseVouchers, documentState.totalAmount);
    const interestDates = getInterestDates(caseVouchers, documentState.interestDates);
    const interests = getInterests(caseVouchers, documentState.interests);
    const fuldtAnsvarligDeltagere = customer && getFuldtAnsvaligeDeltagere(customer.users);
    const director = customer && getDirector(customer.users);
    const caseInterest = getCaseInterest(caseVouchers, documentState.caseInterest);
    useEffect(() => {
        if (creditor && caseInteractions && caseUpdates && templates) {
            // Set sagsfremstilling
            const newEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft.default(encodeText(creditor.settings?.courtSubmitConfig?.sagsfremstilling ||
                documentState.bpDesc ||
                utils.bpkDescTemplate, mentionSuggestions)).contentBlocks));
            const _remindingDate = getWarningDate(caseInteractions, caseUpdates, templates);
            // Set court settings
            setDocumentState({
                ...documentState,
                ...(_remindingDate ? { remindingDate: moment(_remindingDate) } : {}),
                ...(typeof creditor.settings.courtSubmitConfig?.preventForkyndt ===
                    'boolean'
                    ? {
                        preventForkyndt: creditor.settings.courtSubmitConfig.preventForkyndt,
                    }
                    : {}),
                ...(typeof creditor.settings.courtSubmitConfig?.preventAutDistress ===
                    'boolean'
                    ? {
                        preventAutDistress: creditor.settings.courtSubmitConfig.preventAutDistress,
                    }
                    : {}),
                ...(typeof creditor.settings.courtSubmitConfig
                    ?.notDirectlyToCivilCourt === 'boolean'
                    ? {
                        notDirectlyToCivilCourt: creditor.settings.courtSubmitConfig.notDirectlyToCivilCourt,
                    }
                    : {}),
                ...(typeof creditor.settings.courtSubmitConfig
                    ?.sendInfoToEconomyResponsible === 'boolean'
                    ? {
                        sendInfoToEconomyResponsible: creditor.settings.courtSubmitConfig
                            ?.sendInfoToEconomyResponsible,
                    }
                    : {}),
                ...(typeof creditor.settings.courtSubmitConfig
                    ?.addCourtDisbursementToClientBilling === 'boolean'
                    ? {
                        addCourtDisbursementToClientBilling: creditor.settings.courtSubmitConfig
                            ?.addCourtDisbursementToClientBilling,
                    }
                    : {}),
                ...(typeof creditor.settings.courtSubmitConfig
                    ?.addCourtFeeToClientBilling === 'boolean'
                    ? {
                        addCourtFeeToClientBilling: creditor.settings.courtSubmitConfig?.addCourtFeeToClientBilling,
                    }
                    : {}),
            });
            if (creditor.settings.courtSubmitConfig?.economyResponsibleUserId) {
                setEconomyResponsibleUserId(creditor.settings.courtSubmitConfig?.economyResponsibleUserId);
            }
            setEditorState(newEditorState);
        }
    }, [creditor, caseInteractions, templates]);
    const setDocumentState = (addToState) => {
        const newState = {
            ...documentState,
            ...addToState,
        };
        if (addToState.bpDesc &&
            creditor?.settings?.courtSubmitConfig?.sagsfremstilling) {
            // Dot not update bdDesc if set on creditor
        }
        else {
            utils.setLocalModel(newState);
        }
        setDocumentReactState(newState);
    };
    if (typeof documentState.processInterest === 'undefined') {
        setDocumentState({
            processInterest: caseVouchers.some((v) => v.voucherTypeId === VoucherTypeIds.PROCESSINTEREST),
        });
    }
    const getSupplementaryData = () => ({
        court,
        content: editorState
            ? parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions)
            : '',
        courtFee: formatNumber(courtFee),
        remindingDate: remindingDate && remindingDate.locale('da').format('LL'),
        interestDates,
        interests,
        processInterest,
        interestFromSubmitOfBPK,
        preventForkyndt,
        preventAutDistress,
        notDirectlyToCivilCourt,
        totalAmount,
        createDate: (createDate && createDate.locale('da').format('LL')),
        fuldtAnsvarligDeltagere,
        director,
        caseInterest,
        participatePhoneMeeting,
    });
    const createTribunalCase = async () => {
        if (singleCase) {
            setLoading(true);
            if (!court) {
                throw new Error('Could not find court');
            }
            try {
                await tribunalAPI.createTribunalJob({
                    type: props.resending
                        ? GLTribunalJobType.GLResendBetalingspaakrav
                        : GLTribunalJobType.GLCreateBetalingspaakrav,
                    tribunalCaseId: props.tribunalCaseId,
                    data: {
                        courtId: court.courtId,
                        sendInfoToEconomyResponsible,
                        economyResponsibleUserId,
                        addCourtFeeToCase,
                        addCourtFeeToClientBilling,
                        addCourtDisbursementToClientBilling,
                        courtFee,
                        sagsfremstilling: editorState
                            ? parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions)
                            : '',
                        remindingDate: (remindingDate && remindingDate.format()),
                        interestDates,
                        interests,
                        processInterest,
                        interestFromSubmitOfBPK,
                        preventForkyndt,
                        preventAutDistress,
                        notDirectlyToCivilCourt,
                        totalAmount: totalAmount,
                        createDate: (createDate && createDate.format()),
                        fuldtAnsvarligDeltagere,
                        director,
                        caseInterest,
                        participatePhoneMeeting,
                    },
                    caseId: singleCase.caseId,
                    reference: null,
                });
                if (singleCase) {
                    await c.caseVouchers.getByCaseId(singleCase.caseId);
                    await c.cases.getUpdates(singleCase.caseId);
                    q.invalidate([...keys.write.create(caseVouchersEntity)]);
                }
                props.onCreated && props.onCreated();
            }
            catch (err) {
                alert(lang.tribunal.couldNotCreateTribunalCase);
            }
            setLoading(false);
            q.invalidate([
                ...keys.write.create(tribunalJobsEntity),
                ...keys.write.create(tribunalCasesEntity),
            ]);
        }
        else {
            throw new Error('Could not find single case');
        }
    };
    const submitValidation = creditor?.settings.courtSubmitConfig &&
        caseVouchers &&
        customer &&
        caseInteractions &&
        caseUpdates &&
        documents &&
        templates &&
        tenant &&
        readyToSubmit({
            creditor,
            caseVouchers,
            customer,
            documents,
            interactions: caseInteractions,
            updates: caseUpdates,
            templates,
            tenant,
        }, creditor?.settings.courtSubmitConfig);
    return (React.createElement("div", null,
        submitValidation &&
            submitValidation.errors.map((error) => (React.createElement(Alert, { message: lang.courtSubmitErrors[error], size: "small", key: error }))),
        React.createElement(CourtSelect, { caseSeqId: props.caseSeqId, court: court, setDocumentState: setDocumentState }),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", null, "Rubrik 1"),
                React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: 'Ønsker du at deltage telefonisk i kredsretten?', checked: documentState.participatePhoneMeeting, onChange: (e) => {
                        setDocumentState({
                            participatePhoneMeeting: e.target.checked,
                        });
                    } }))),
        React.createElement(Interest, { interestDates: interestDates, interests: interests, setDocumentState: setDocumentState, processInterest: !!documentState.processInterest, totalAmount: totalAmount, caseInterest: caseInterest, interestFromSubmitOfBPK: !!documentState.interestFromSubmitOfBPK }),
        editorState && (React.createElement(BPDescInput, { bpDesc: documentState.bpDesc, setDocumentState: setDocumentState, editorState: editorState, setEditorState: (es) => {
                if (!sagsfremstillingEdited)
                    setSagsfremstillingEdited(true);
                setEditorState(es);
            } })),
        sagsfremstillingEdited &&
            creditor?.settings.courtSubmitConfig?.sagsfremstilling &&
            meRole &&
            isAdmin(meRole) && (React.createElement("p", null,
            React.createElement(Button, { size: "small", onClick: async () => {
                    if (creditor) {
                        setSagsfremstillingEdited(false);
                        try {
                            await creditorsAPI.update(creditor.creditorId, {
                                settings: {
                                    ...creditor.settings,
                                    courtSubmitConfig: {
                                        ...creditor?.settings.courtSubmitConfig,
                                        sagsfremstilling: editorState
                                            ? parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions)
                                            : '',
                                    },
                                },
                            });
                            q.invalidate(keys.write.modify(creditorsEntity, creditor.creditorId));
                        }
                        catch (error) {
                            alert('Error saving');
                        }
                    }
                } }, "Gem sagsfremstilling p\u00E5 kreditor"))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", null, "Rubrik 5"),
                React.createElement(DateInput, { placeholder: lang.documents.selectBPKWarningDate, value: remindingDate, onChange: (e) => setDocumentState({
                        remindingDate: e,
                    }), allowNull: true }))),
        React.createElement(Rubrik6, { preventForkyndt: preventForkyndt, setDocumentState: setDocumentState, preventAutDistress: preventAutDistress, notDirectlyToCivilCourt: notDirectlyToCivilCourt }),
        React.createElement(Rubrik7, { courtFee: courtFee, sendInfoToEconomyResponsible: sendInfoToEconomyResponsible, addCourtFeeToCase: addCourtFeeToCase, addCourtDisbursementToClientBilling: addCourtDisbursementToClientBilling, addCourtFeeToClientBilling: addCourtFeeToClientBilling, setDocumentState: setDocumentState, economyResponsibleUserId: economyResponsibleUserId, setEconomyResponsibleUserId: setEconomyResponsibleUserId }),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", null, "Rubrik 8"),
                React.createElement(Row, null,
                    React.createElement(Col, { width: "6" },
                        React.createElement(DateInput, { placeholder: lang.documents.createDate, value: createDate, onChange: (e) => setDocumentState({
                                createDate: e,
                            }), allowNull: true }))))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { size: "small", onClick: createTribunalCase, disabled: !(singleCase &&
                            court &&
                            court.courtId &&
                            remindingDate &&
                            interestDates &&
                            interests &&
                            totalAmount &&
                            createDate), loading: loading }, lang.tribunal.createTribunalCase),
                    React.createElement(Button, { size: "small", theme: "secondary", onClick: () => setPreviewModalOpen(!previewModalOpen) }, lang.documents.preview)))),
        previewModalOpen && (React.createElement(Modal, { header: lang.documents.preview, onToggle: () => setPreviewModalOpen(!previewModalOpen) }, props.caseSeqId && singleCase ? (React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/templates/file${templatesAPI.genLetterUrl('c0f5b909-f09b-423c-b2e3-4ff93b1e0149', // GL Betalingspaakrav template
            singleCase.caseId, getSupplementaryData(), `Betalingspåkrav`)}` })) : (React.createElement("h3", { style: {
                margin: '4em 0',
                opacity: 0.7,
                textAlign: 'center',
            } }, lang.templates.selectTestCase))))));
};
export default Betalingspaakrav;
const BPKPreview = () => { };
//# sourceMappingURL=Betalingspaakrav.js.map